import { render, staticRenderFns } from "./OutputTax.vue?vue&type=template&id=50ccf26c&scoped=true&"
import script from "./OutputTax.vue?vue&type=script&lang=js&"
export * from "./OutputTax.vue?vue&type=script&lang=js&"
import style0 from "./OutputTax.vue?vue&type=style&index=0&id=50ccf26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ccf26c",
  null
  
)

export default component.exports